import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import { payMobx } from '@mobxStore'
import { stripeConfigG } from '@ctrls/third'
import AppleSimpleItem from './SimpleItem'

const MethodItem = ({ selected, method, onChange }: { selected?: boolean; method?: any; onChange?: () => void }) => {
  const amount = method?.amount
  const [isShow, setIsShow] = useState<boolean>(false)

  const handleChange = () => {
    onChange()
  }

  useEffect(() => {
    const channelType = payMobx.methodChannelMap.applePay
    if (channelType === 'StripeApplePay') {
      stripeConfigG.init(() => {
        setIsShow(true)
      })
    }
    return () => {
      stripeConfigG.remove()
    }
  }, [payMobx.methodChannelMap])

  return (
    isShow && <AppleSimpleItem selected={selected} amount={amount} onChange={handleChange} />
  )
}

export default observer(MethodItem)
